import { GoChevronDown } from "react-icons/go";
import { useEffect, useState, Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";

import SearchBar from "../Common/searchBar";
import UserTable from "./UserTable/userTable";
import Pagination from "../Common/pagination";

import { API, apiClient } from '../../../Common/lib/api';
import { GetUserGroup } from "../../../Common/lib/Admin/AdminAPI";
import SortSearch from "./sortSearch";

/**
 * Returns the User Search Data component.
 *
 * @returns the User Search Data component.
 */
const VerifiedUser = ({
    setShow,
    selectedUserHandler,
}) => {
    const [pageLoading, setPageLoading] = useState(true);

    const [sortBy, setSortBy] = useState("");

    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [noSearchResults, setNoSearchResults] = useState(false);

    const [totalUsers, setTotalUsers] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(6);

    /**
     * Gets all of the Users with their roles.
     */
    const fetchUserWithGroups = async () => {
        try {
            const response = await apiClient.get('/admin/users/');
            const users = response.data.Users || [];
            
            const usersList = users.map((row) => {
                const attributes = {};
                row.Attributes.forEach(attr => {
                    attributes[attr.Name] = attr.Value;
                });

                return {
                    role: row.Role || 'UnverifiedUser',
                    username: row.Username,
                    id: row.id,
                    fname: attributes.given_name || '',
                    lname: attributes.family_name || '',
                    email: attributes.email || row.Username,
                    phone: attributes.phone_number || '',
                    userEmail: attributes.email || row.Username,
                    contributorAccess: row.ContributorAccess || false,
                    action: "test",
                };
            });

            setFilteredData(usersList);
            setTotalUsers(usersList.length);
            setPageLoading(false);
        } catch (error) {
            console.error('Error fetching users:', error);
            setPageLoading(false);
            setFilteredData([]);
            setTotalUsers(0);
        }
    };

    useEffect(() => {
        fetchUserWithGroups();
    }, []);

    /**
     * Handles the project search input field.
     *
     * @param {Event Handles} event
     */
    const handleSearch = (event) => {
        setSearchTerm((event.target.value).trim());
    };

    /**
     * Handles the search form onSubmit.
     *
     * @param {Event Handles} event
     */
    const onSearchSubmit = (event) => {
        event.preventDefault();

        setSortBy("");
        setNoSearchResults(false);

        // Searches the array of users based on the search term
        const filteredResults = filteredData.filter((user) =>
            user.fname.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.lname.toLowerCase().includes(searchTerm.toLowerCase()) ||
            `${user.fname.toLowerCase()} ${user.lname.toLowerCase()}`.includes(searchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(searchTerm.toLowerCase())
        );

        if (filteredResults.length !== 0) {
            setFilteredData(filteredResults);
        } else {
            setNoSearchResults(true);
        }
    };

    /**
     * Logic behind the pagination and selection of users based on the current page.
     * API does not have the functionality same as the queries with the FROM and LIMIT properties.
     */
    const startIndex = (currentPage) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const visibleData = filteredData.slice(startIndex, endIndex);

    return (
        <>
            <div className="flex-1 shadow ring-1 ring-black ring-opacity-5">
                {pageLoading ? (
                    <>
                        <div className="text-base p-40 bg-gray-100 place-content-center">
                            <p className="text-center font-medium">
                                Loading
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="flex justify-between">
                            {/* Search User Component */}
                            <SearchBar
                                searchPurpose={"user"}
                                searchTerm={searchTerm}
                                currentPage={currentPage}
                                handleSearch={handleSearch}
                                setCurrentPage={setCurrentPage}
                                onSearchSubmit={onSearchSubmit}
                            />

                            {/* Sorting Component */}
                            <SortSearch
                                sortBy={sortBy}
                                setSortBy={setSortBy}
                            />
                        </div>

                        {noSearchResults ? (
                            <div className="text-base p-40 bg-gray-100 place-content-center">
                                <p className="text-center font-medium">
                                    No Users Found!
                                </p>
                            </div>
                        ) : (
                            <>
                                <UserTable
                                    sortBy={sortBy}
                                    setShow={setShow}
                                    rows={visibleData}
                                    selectedUserHandler={selectedUserHandler}
                                />

                                <Pagination
                                    projectCount={totalUsers}
                                    projectsPerPage={itemsPerPage}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default VerifiedUser;